import { Div } from "@hopper-ui/components";
import styles from "./HomeAnimatedBackground.module.css";

export function HomeAnimatedBackground() {
    return (
        <Div zIndex={-1} position="fixed" left="30%" top="50%" UNSAFE_width="80vw" UNSAFE_height="62vh">
            <Div
                className={styles["breathe"]}
                style={{ animationDuration: "50s" }}
                position="absolute"
                top="5%"
                left={0}
                width="45%"
                height="57%"
                borderRadius="circle"
                backgroundColor="core_persimmon-300"
                filter="blur(max(10vw, 15vh))"
            />
            <Div
                className={styles["breathe"]}
                style={{ animationDuration: "46s", animationFillMode: "backwards" }}
                position="absolute"
                top="60%"
                left="30%"
                width="32%"
                height="41%"
                borderRadius="circle"
                backgroundColor="core_limeburst-50"
                filter="blur(max(10vw, 15vh))"
            />
            <Div
                className={styles["breathe"]}
                style={{ animationDuration: "60s" }}
                position="absolute"
                top={0}
                left="40%"
                width="60%"
                height="76%"
                borderRadius="circle"
                backgroundColor="core_iris-200"
                filter="blur(max(10vw, 15vh))"
            />
        </Div>
    );
}
